<template>
  <!-- intro -->
  <section class="intro pb-5 text-center text-lg-start">
    <!-- bg image -->
    <img
      src="@/assets/images/bg/header-bg.svg"
      alt="intro bg"
      class="intro__bg"
    />
    <!-- end bg image -->

    <!-- shadow images -->
    <img
      src="@/assets/images/shadow-bg.png"
      alt="shadow bg"
      class="shadow-bg shadow-bg--left"
    />
    <img
      src="@/assets/images/shadow-bg.png"
      alt="shadow bg"
      class="shadow-bg shadow-bg--right"
    />
    <!-- end shadow images -->

    <div class="container">
      <div class="row align-items-center flex-lg-nowrap">
        <!-- intro__content -->
        <div
          class="col-lg-6 mb-4 mb-lg-5 pb-lg-5 intro__content order-2 order-lg-1"
        >
          <div>
            <h1
              class="intro__title mb-0"
              data-aos="fade-right"
              data-aos-offset="0"
            >
              <span>PLAY</span><strong>4</strong> <br />
              PURPOSE
            </h1>

            <button
              class="button button--full-left-border intro__btn mt-5"
              data-aos="fade-right"
              data-aos-delay="500"
              data-aos-offset="0"
            >
              <span class="me-5">JOIN NOW</span>
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.55273 2.33449L6.76048 7.54225L1.55273 12.75"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.792 2.33449L16.9997 7.54225L11.792 12.75"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

            <!-- partners -->
            <div
              class="partners pt-2 px-0 mt-5 mb-lg-5 col-lg-8"
              data-aos="fade-up"
              data-aos-offset="0"
            >
              <div
                class="row align-items-center justify-content-center justify-content-sm-start text-center"
              >
                <div class="col-3" v-for="i in 4" :key="i">
                  <div>
                    <div class="partner__img">
                      <img
                        :src="require(`@/assets/images/partners/${i}.svg`)"
                        alt="partner image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end partners -->
          </div>
        </div>
        <!-- end intro__content -->

        <!-- intro__shape -->
        <div class="intro__shape col-lg-8 order-1 order-lg-2 mb-4 mb-lg-0">
          <div>
            <div class="intro__img" data-aos="zoom-in" data-aos-duration="1500">
              <img
                src="@/assets/images/icons/triangle.svg"
                alt="triangle icon"
                class="triangle-icon rotate-360"
              />
              <img
                src="@/assets/images/icons/x.svg"
                alt="x icon"
                class="x-icon rotate-360"
              />
              <!-- <img
                src="@/assets/images/icons/circle.svg"
                alt="circle icon"
                class="circle-icon rotate-360"
              /> -->
              <img
                src="@/assets/images/icons/square.svg"
                alt="square icon"
                class="square-icon rotate-360"
              />

              <img
                src="@/assets/images/intro-new.svg"
                alt="intro image"
                data-aos="scale"
                data-aos-delay="400"
              />
              <img
                src="@/assets/images/smoke.svg"
                alt="smoke image"
                class="smoke-img"
              />
              <img
                src="@/assets/images/intro-circle.svg"
                alt="circle image"
                class="intro__img__circle"
              />
            </div>
          </div>
        </div>
        <!-- end intro__shape -->
      </div>
    </div>
  </section>
  <!-- end intro -->
</template>

<script>
export default {
  name: "home-intro",
};
</script>
